import { intlFormatDateShort } from "../time-utils";

interface TextFragmentInterface {
  text: string;
  color?: React.CSSProperties["color"];
  fontSize?: React.CSSProperties["fontSize"];
  fontWeight?: React.CSSProperties["fontWeight"];
  fontFamily?: React.CSSProperties["fontFamily"];
  fontStyle?: React.CSSProperties["fontStyle"];
}

export const createSVGFileFromText = (
  textFragments: TextFragmentInterface[],
  fileName: string,
  viewBox?: string,
  width?: React.CSSProperties["width"],
  height?: React.CSSProperties["height"]
): File => {
  const svgContent = `<svg viewBox="${
    viewBox ?? "0 0 240 80"
  }" xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">
        ${textFragments.map(
          ({ text, color, fontSize, fontWeight, fontFamily, fontStyle }) =>
            `<text 
                fill="${color ?? "currentColor"}"
                font-size="${fontSize}"
                font-weight="${fontWeight}"
                font-family="${fontFamily}"
                font-style="${fontStyle}"
                >
                ${text}
                
            </text>`
        )}
    </svg>`;

  const _blob = new Blob([svgContent], { type: "image/svg+xml" });
  const _file = new File([_blob], fileName ?? `svg_${intlFormatDateShort(new Date())}`);
  return _file;
};
